import { css } from '@emotion/react';
import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import t from 'react-translate';
import prodPathReplace from 'shared/prod-path-rewrite';
import MentoringProgramContext from '../context';


const GuidesTurnedOff = () => {
  const translationBase = t.MENTORING_PROGRAMS.GUIDANCE.GUIDES;

  const styles = css`
    img {
      height: 130px;
      width: 190px;
    }
  `;

  const { mentoringProgram } = useContext(MentoringProgramContext);
  const { guidesCount } = mentoringProgram || {};

  return (
    <div css={styles} className='d-flex flex-column justify-content-center align-items-center p-5 bg-blue05'>
      <img src={prodPathReplace('images/guides-disabled.png')} alt='' />
      <div className='text-center my-4'>
        <div className='semi-bold'>{translationBase.GUIDANCE_DISABLED.TITLE()}</div>
        <div className='mt-2'>
          {translationBase.GUIDANCE_DISABLED.DESCRIPTION()}
        </div>
        {!!guidesCount && (
          <div className='mt-2'>
            {translationBase.GUIDANCE_DISABLED.NUM_GUIDES_AVAILABLE(guidesCount)}
          </div>
        )}
      </div>
      <Button
        variant='primary'
        className='d-flex flex-row align-items-center'
      >
        <Link
          to='/settings/guidance'
          className='color-white'
          aria-label={translationBase.GUIDANCE_DISABLED.TURN_ON()}
        >
          {translationBase.GUIDANCE_DISABLED.TURN_ON()}
        </Link>
      </Button>
    </div>
  );
};

export default GuidesTurnedOff;
